import {
  Checkbox,
  DefaultButton,
  PrimaryButton,
  TextField,
  ChoiceGroup,
  Dropdown,
} from "@fluentui/react";
import CustomMultiSelect from "../../../../components/CustomMultiSelect";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { t } from "i18next";
import MobileInput from "../../../../components/MobileInput";
import UserDetails from "../../components/UserDetails";
import ContactDetails from "../../components/ContactDetails";
import UserProfileDetails from "../../components/UserProfileDetails";
import { TOAST_TYPE, USERTYPES } from "../../../../constants/Constants";
import { assignmentConfirmationOptions, userAccountOptions } from "../../helpers/CheckboxOptions";
import { choiceGroupStyles } from "../../helpers/Styles";
import { ACTIONS } from "../../../../constants/Constants";
import { activeStatusOptions } from "../../helpers/CheckboxOptions";
import { radiologistTimeSpentOptions } from "../../helpers/CheckboxOptions";
import { radiologistTypeOptions, typistWorkflowOptions } from "../../helpers/CheckboxOptions";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import { forEach } from "underscore";
import userContext from "../../../../context/users/UserContext";
import "../../helpers/InputFileContainerCSS.css";
import PasswordAuthModal from "../../../../components/PasswordResetModal/PasswordAuthModal";
import toastContext from "../../../../context/toast/ToastContext";
import { getEnv } from '../../../../helpers/EnvHelper';

const dropDownStyle = {
  dropdown: {
    width: "100%",
  },
  dropdownItemSelected: {
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "400",
  },
  dropdownItemsWrapper: {
    maxHeight: "300px",
  },
  dropdownItem: {
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "400",
  },
};

const SettingSection = (props) => {
  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;
  let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM")=="true"||getEnv("REACT_APP_BVP_PLATFORM")==true)?true:false;
  const [radiologistSignatureImage, setRadiologistSignatureImage] = useState(props.radiologistSignatureImage ? true : false);
  const [qcSupervisor, setQcSupervisor] = useState(props.values.qcSupervisor);
  const [savingTwoFA, setSavingTwoFA] = useState(false);
  const [twoFA, setTwoFA] = useState(!!props.values.twoFactorEnabled);
const [authVisible, setAuthVisible] = useState(false);
const [pendingDisable, setPendingDisable] = useState(false);
const [saving, setSaving] = useState(false);
const [radiologistOptions, setRadiologistOptions] = useState([]);

// prevent immediate overwrite from props while we’re completing the disable flow
const [suppressPropSync, setSuppressPropSync] = useState(false);

  const { roles, authenticated, loadByUsername, userId, twoFAGlobalEnable ,username} =
    useContext(userContext);
  const { showToastv2 } =
      useContext(toastContext);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  useEffect(() => {
    if (props.userType === USERTYPES.TYPIST && (roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN)) {
      const data = props.userData?.connectedRadiologistOptions;
      if (data) {
        const options = data.map((r) => ({
          key: String(r.id),
          text: (r.firstName && r.lastName) ? `${r.firstName} ${r.lastName}` : r.username,
        }));
        setRadiologistOptions(options);
      }
    }
  }, [props.userType, roles, props.userData]);

  const setActive = useCallback((e, option) => {
    props.values.active = option.key === "true" ? true : false;
  });

  const setLocked = useCallback((e, option) => {
    props.values.accountNonLocked = option.key === "true" ? true : false;
  });

  const setShowAssignmentConfirmation = useCallback((e, option) => {
    props.values.showConfirmation = option.key === "true" ? true : false;
  });

  const setShowRadiologistTime = useCallback((e, option) => {
    props.values.showRadiologistTime = option.key === "true" ? true : false;
  });

  let modalityList = [];
  props.modalityList.map((modality) => {
    modalityList.push({
      key: modality.id,
      text: modality.name,
    });
  });

  const setRadiologistType = useCallback((e, option) => {
    props.values.radiologistType = option.key;
    if (props.values.radiologistType === 2) {
      props.setExpertRadiologist(true);
      props.values.signatureText = "";
      props.values.signatureImage = null;
    } else {
      props.setExpertRadiologist(false);
    }
  });

  const getTextValue = (key, array) => {
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        return array[i].text;
      }
    }
  };
// Only resync from props when not in the middle of the gated flow
useEffect(() => {
  if (suppressPropSync) return;
  setTwoFA(!!props.values.twoFactorEnabled);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [props.values.twoFactorEnabled]);



// optional: persist to backend (or remove if you save on form submit)
const commitTwoFAChange = async (next) => {
  try {
    setSavingTwoFA(true);
    // await updateTwoFactorSetting(props.values.username, next); // your API
  } finally {
    setSavingTwoFA(false);
  }
};

// Fluent UI: onChange = (ev?, checked?: boolean)
const handleTwoFactorToggle = (_ev, checked) => {
  const next = !!checked;

  // Turning OFF → gate behind password
  if (twoFA && !next) {
    setPendingDisable(true);
    setSuppressPropSync(true); // don't let props flip us back while authenticating
    setAuthVisible(true);
    return;
  }

  // Turning ON → optimistic
  setTwoFA(true);
  props.setFieldValue?.("twoFactorEnabled", true); // Formik
  props.values.twoFactorEnabled= true;
  // If you persist immediately:
  // await updateTwoFactorSetting(props.values.username, true)
};

  const allowedFileTypes = [
    ".JPEG",
    ".jpeg",
    ".PNG",
    ".png",
    ".JPG",
    ".jpg"
  ];


  return (
    <>
      <PasswordAuthModal
        visible={authVisible}
        username={username}
        onClose={() => setAuthVisible(false)}
        onResult={async (ok) => {
          // 1) close the modal first (you asked: show toast when modal is false)
          setAuthVisible(false);

          if (ok && pendingDisable) {
            // 2) update UI + form immediately
            setTwoFA(false);
            props.setFieldValue?.("twoFactorEnabled", false);

            try {
              setSaving(true);
              // Persist the change (rename to your real API)
              await commitTwoFAChange(false);
              // 3) success toast
              props.values.twoFactorEnabled= false;
              showToastv2(TOAST_TYPE.SUCCESS, "MFA is disabled successfully!");
            } catch (e) {
              // rollback on failure
              setTwoFA(true);
              props.setFieldValue?.("twoFactorEnabled", true);
              showToastv2(TOAST_TYPE.ERROR, "MFA is not disabled!");
            } finally {
              setSaving(false);
            }
          } else if (pendingDisable) {
            // wrong password or user cancelled
            showToastv2(TOAST_TYPE.ERROR, "MFA is not disabled!");
          }

          setPendingDisable(false);
          setSuppressPropSync(false);
        }}
      />

      <div className="tab-section">
        {!isMobile && (
          <section className="sectionA">
            <p
              style={{
                fontSize: "20px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("user.settings")}
            </p>
          </section>
        )}
        <div className="ms-Grid" dir="ltr">
          {(props.state.action === ACTIONS.ADD ||
            props.state.action === ACTIONS.EDIT) && (
            <>
              {/* ACTIVE STATUS OPTION TO BE SHOWN ONLY WHEN LOGGED IN USER IS NOT UPDATING ITSELF  */}
              {(props.state.action === ACTIONS.EDIT || (props.state.action === ACTIONS.ADD && props.userType === USERTYPES.TYPIST )) &&
                userId != props.values.id && (
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.action")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.active ? "true" : "false"
                          }
                          options={activeStatusOptions}
                          styles={choiceGroupStyles}
                          onChange={setActive}
                        />
                      </div>
                    </div>
                  </div>
                )}

            {(!(roles[0]  === USERTYPES.ADMIN  && props.values.username == 'dtadmin')) 
              && (!(roles[0]  === USERTYPES.FIRMADMIN 
              && props.userType === USERTYPES.RADIOLOGIST
              && props.values.countOfconnections > 1)) && (
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.locked-status")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.accountNonLocked ? "true" : "false"
                          }
                          options={userAccountOptions}
                          styles={choiceGroupStyles}
                          onChange={setLocked}
                        />
                      </div>
                    </div>
                  </div>
                )}

              {twoFAGlobalEnable &&
                (!(roles[0] === USERTYPES.ADMIN && props.values.username == "dtadmin")) &&
                !(roles[0] === USERTYPES.FIRMADMIN && props.userType === USERTYPES.RADIOLOGIST) && (
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">{t("user.two-factor")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                      <Checkbox
                        checked={twoFA}
                        onChange={handleTwoFactorToggle}
                        disabled={saving}
                      />
                      </div>
                    </div>
                  </div>
                )}
              
              {((props.state.action === ACTIONS.EDIT || props.state.action === ACTIONS.ADD) && props.userType === USERTYPES.TYPIST ) &&
                userId != props.values.id && (
                 
                    <div
                    className="ms-Grid-row single-line-form-field"
                  
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.enable-ms-word")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.showWord}
                          value={props.values.showWord}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.showWord =
                              !props.values.showWord;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  
                )}

              {/* TYPIST PERMISSION FLAGS — visible only when Admin/FirmAdmin edits a Typist */}
              {(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN) && props.userType === USERTYPES.TYPIST && (
                <>
                  {/* Show All Studies */}
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.show-all-studies")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          checked={props.values.showAllStudy}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            const next = !props.values.showAllStudy;
                            props.setFieldValue("showAllStudy", next);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Connected Radiologists dropdown — only when Show All Studies is checked */}
                  {props.values.showAllStudy && (
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          Connected Radiologists
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <CustomMultiSelect
                          options={radiologistOptions}
                          placeholder="Select radiologists"
                          searchPlaceholder="Search radiologists"
                          selectedKeys={(props.values.connectedRadiologistIds || []).map(id => String(id))}
                          setSelectedKeys={(keys) => {
                            props.setFieldValue("connectedRadiologistIds", keys || []);
                          }}
                          showSelectAll={true}
                          calloutProps={{ doNotLayer: true }}
                        />
                        {(props.values.connectedRadiologistIds || []).length > 0 && (
                          <div
                            style={{ marginTop: 4, fontSize: 12, color: "#666", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                            title={(props.values.connectedRadiologistIds || [])
                              .map((id) => {
                                const opt = radiologistOptions.find((o) => o.key === String(id));
                                return opt ? opt.text : id;
                              })
                              .join(", ")}
                          >
                            Selected:{" "}
                            {(props.values.connectedRadiologistIds || [])
                              .map((id) => {
                                const opt = radiologistOptions.find((o) => o.key === String(id));
                                return opt ? opt.text : id;
                              })
                              .join(", ")}
                          </div>
                        )}
                        {props.errors.connectedRadiologistIds && (
                          <div style={{ color: "#ff0000", marginTop: 4, fontSize: 12, fontWeight: 700 }}>
                            {props.errors.connectedRadiologistIds}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Show Add Study */}
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">Show Add Study
                        {props.errors.showAllStudy && (
                      <p style={{ color: "#ff0000", fontSize: 12, fontWeight: 700 }}>
                        {props.errors.showAllStudy}
                      </p>
                    )}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          checked={props.values.showAddStudy}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            const next = !props.values.showAddStudy;
                            props.setFieldValue("showAddStudy", next);
                          }}
                        />
                      </div>
                    </div>
                    </div>

                  {/* Show History */}
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">Show History</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.showHistory}
                          value={props.values.showHistory}
                          styles={choiceGroupStyles}
                          onChange={() => { props.values.showHistory = !props.values.showHistory; }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Show Viewer */}
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">Show Viewer</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.showViewer}
                          value={props.values.showViewer}
                          styles={choiceGroupStyles}
                          onChange={() => { props.values.showViewer = !props.values.showViewer; }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Show Chats */}
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">Show Chats</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.showChats}
                          value={props.values.showChats}
                          styles={choiceGroupStyles}
                          onChange={() => { props.values.showChats = !props.values.showChats; }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Allow Submit */}
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">Allow Submit</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.allowSubmit}
                          value={props.values.allowSubmit}
                          styles={choiceGroupStyles}
                          onChange={() => { props.values.allowSubmit = !props.values.allowSubmit; }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* SHOW ASSIGNMENT CONFIRMATION OPTION TO BE SHOWN ONLY WHEN USER TYPE IS ADMIN/FIRMADMIN/SUPERVISOR  */}
              {(props.userType === USERTYPES.ADMIN ||
                props.userType === USERTYPES.FIRMADMIN ||
                props.userType === USERTYPES.SUPERVISOR) && (
                  <>
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key">
                      {t("user.show-assignment-confirmation")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <ChoiceGroup
                        defaultSelectedKey={
                          props.values.showConfirmation ? "true" : "false"
                        }
                        options={assignmentConfirmationOptions}
                        styles={choiceGroupStyles}
                        onChange={setShowAssignmentConfirmation}
                      />
                    </div>
                  </div>
                </div>
                

                <div className="ms-Grid-row single-line-form-field">
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key">
                      {t("user.enable-ms-word")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <Checkbox
                        defaultChecked={props.values.showWord}
                        value={props.values.showWord}
                        styles={choiceGroupStyles}
                        onChange={() => {
                          props.values.showWord =
                            !props.values.showWord;
                        }}
                      />
                    </div>
                  </div>
                </div> 
                {getEnv("REACT_APP_VDC_PLATFORM")=="true" && <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("heading.peer-review")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.isPeerReviewAdmin
                              ? "Team Member"
                              : props.values.isPeerReviewEvaluator
                              ? "Evaluator"
                              : "None"
                          }
                          options={[
                            {
                              key: "Team Member",
                              text: t("peer-review.peer-review-admin"),
                            },
                            {
                              key: "Evaluator",
                              text: t("peer-review.evaluator"),
                            },
                            { key: "None", text:"None" },

                          ]}
                          styles={choiceGroupStyles}
                          onChange={(event, option) => {
                            if (option.key === "Team Member") {
                              props.values.isPeerReviewAdmin = true;
                              props.values.isPeerReviewEvaluator = false;
                            } else if (option.key === "Evaluator") {
                              props.values.isPeerReviewAdmin = false;
                              props.values.isPeerReviewEvaluator = true;
                            } else if (option.key === "None") {
                              props.values.isPeerReviewAdmin = false;
                              props.values.isPeerReviewEvaluator = false;
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>}

                </>
              )}
               {
               (roles[0]  === USERTYPES.ADMIN && props.userType === USERTYPES.FIRMADMIN) &&
               (
                <>
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.password-reset-allowed")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        {console.log("Is password reset allowed",props.values.isPasswordResetAllowed)}
                        <Checkbox
                          defaultChecked={props.values.isPasswordResetAllowed}
                          value={props.values.isPasswordResetAllowed}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.isPasswordResetAllowed =
                              !props.values.isPasswordResetAllowed;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {
               (roles[0]  === USERTYPES.ADMIN && (props.userType === USERTYPES.FIRMADMIN || props.userType === USERTYPES.SUPERVISOR)) &&
               (
                <>
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.forced-logout-allowed")}
                          <p style={{
                            fontSize: "12px",
                            fontStyle: "italic",
                          }}>
                      Force logout allowed for Radiologists and Supervisors
                    </p>
                      </p>
                       
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>

                                 <Checkbox
                                defaultChecked={props.values.isForcedLogoutAllowed}
                                value={props.values.isForcedLogoutAllowed}
                                styles={choiceGroupStyles}
                                onChange={() => {
                                  props.values.isForcedLogoutAllowed =
                              !props.values.isForcedLogoutAllowed;
                                }}
                            /> 
                                      
                      </div>
                    </div>
                  </div>
                </>
              )}

              {
                  ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN) && (props.userType === USERTYPES.FIRMTECHNICIAN || props.userType === USERTYPES.SUPERVISOR || props.userType===USERTYPES.FIRMDOCTOR )) &&
                  (
                    <>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.enable-study-upload")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              checked={props.values.enableStudyUpload}
                              styles={choiceGroupStyles}
                              onChange={(e, checked) => {
                                props.values.enableStudyUpload = checked;
                                if (props.setFieldValue) {
                                  props.setFieldValue("enableStudyUpload", checked);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }
                {
                  ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN) && (props.userType===USERTYPES.FIRMDOCTOR )) &&
                  (
                    <>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.show-ai-results")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              checked={props.values.showAiResults}
                              styles={choiceGroupStyles}
                              onChange={(e, checked) => {
                                props.values.showAiResults = checked;
                                if (props.setFieldValue) {
                                  props.setFieldValue("showAiResults", checked);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }
                {
                  ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN) && (props.userType===USERTYPES.FIRMDOCTOR)) &&
                  (
                    <>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.show-saved-report")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              checked={props.values.showSavedReport}
                              styles={choiceGroupStyles}
                              onChange={(e, checked) => {
                                props.values.showSavedReport = checked;
                                if (props.setFieldValue) {
                                  props.setFieldValue("showSavedReport", checked);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }

                {
                  ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN) && (props.userType===USERTYPES.FIRMTECHNICIAN)) &&
                  (
                    <>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.show-viewer-technician")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              checked={props.values.showViewerTechnician}
                              styles={choiceGroupStyles}
                              onChange={(e, checked) => {
                                props.values.showViewerTechnician = checked;
                                if (props.setFieldValue) {
                                  props.setFieldValue("showViewerTechnician", checked);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }
                {
                ((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.FIRMDOCTOR) && (
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.allow-study-edit")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.allowStudyEdit}
                          value={props.values.allowStudyEdit}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.allowStudyEdit = !props.values.allowStudyEdit;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )
              }

              {
                ((roles[0] === USERTYPES.FIRMADMIN || roles[0]===USERTYPES.ADMIN) && (props.userType===USERTYPES.FIRMTECHNICIAN )) &&
                  (
                    <>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.show-ai-results")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              checked={props.values.showAiResults}
                              styles={choiceGroupStyles}
                              onChange={(e, checked) => {
                                props.values.showAiResults = checked;
                                if (props.setFieldValue) {
                                  props.setFieldValue("showAiResults", checked);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }
                {
                  ((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.FIRMTECHNICIAN) && (
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          {t("user.allow-study-edit")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>
                          <Checkbox
                            defaultChecked={props.values.allowStudyEdit}
                            value={props.values.allowStudyEdit}
                            styles={choiceGroupStyles}
                            onChange={() => {
                              props.values.allowStudyEdit = !props.values.allowStudyEdit;
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )
                }
              {(roles[0]  === USERTYPES.ADMIN && (props.userType === USERTYPES.FIRMADMIN || props.userType === USERTYPES.SUPERVISOR || props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN)) &&
               (<>
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.export-csv-allowed")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.isExportCsvAllowed}
                          value={props.values.isExportCsvAllowed}
                          styles={choiceGroupStyles}
                          onChange={(e, checked) => {
                          props.setFieldValue("isExportCsvAllowed", checked);
                        }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
			  
              {/* SHOW RADIOLOGIST TIME SPENT TO BE SHOWN ONLY IN CASE OF SUPERVISOR USER TYPE */}
              {props.userType === USERTYPES.SUPERVISOR && (
                <>
                {((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.SUPERVISOR) && (
                <div className="ms-Grid-row single-line-form-field">
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key">
                      {t("user.allow-delete-study")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <Checkbox
                        defaultChecked={props.values.allowDeleteStudy}
                        value={props.values.allowDeleteStudy}
                        styles={choiceGroupStyles}
                        onChange={() => {
                          props.values.allowDeleteStudy = !props.values.allowDeleteStudy;
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.qc-supervisor")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.qcSupervisor}
                          value={props.values.qcSupervisor}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.qcSupervisor =
                              !props.values.qcSupervisor;
                            setQcSupervisor(props.values.qcSupervisor);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {!!qcSupervisor && (
                    <>
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          {t("user.enable-adding-annotations")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>
                          <Checkbox
                            defaultChecked={props.values.keyImage}
                            value={props.values.keyImage}
                            styles={choiceGroupStyles}
                            onChange={() => {
                              props.values.keyImage = !props.values.keyImage;
                            }}
                          />
                        </div>
                      </div>
                    </div>

                      <div
                      className="ms-Grid-row single-line-form-field"
                      >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          {t("user.enable-save-report")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>
                          <Checkbox
                            defaultChecked={props.values.qcSaveReport}
                            value={props.values.qcSaveReport}
                            styles={choiceGroupStyles}
                            onChange={() => {
                              props.values.qcSaveReport = !props.values.qcSaveReport;
                            }}
                          />
                        </div>
                      </div>
                      </div>

                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.qc-outsource-login")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.qcOutsourceLogin}
                              value={props.values.qcOutsourceLogin}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.qcOutsourceLogin = !props.values.qcOutsourceLogin;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.view-radiologist-time-spent")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={
                            props.values.showRadiologistTime ? "true" : "false"
                          }
                          options={radiologistTimeSpentOptions}
                          styles={choiceGroupStyles}
                          onChange={setShowRadiologistTime}
                        />
                      </div>
                    </div>
                  </div>

                  {!isBvpPlatform && !isVdcPlatform &&(<div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.qc-capacity")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <div>
                          <TextField
                            name="capacity"
                            placeholder={t("user.qc-capacity")}
                            type="number"
                            min={0}
                            onChange={props.handleChange}
                            value={props.values.capacity}
                            onBlur={props.handleBlur}
                            errorMessage={props.errors.capacity}
                          />
                        </div>
                      </div>
                    </div>
                  </div>)}
                </>
              )}
              {
                  (roles[0] === USERTYPES.FIRMADMIN && props.userType === USERTYPES.FIRMTECHNICIAN) &&
                  (
                    <>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("hospital.enableReportAndHeaderTemplateConfigurations")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              checked={props.values.enableReportAndHeaderTemplateConfigurations}
                              styles={choiceGroupStyles}
                              onChange={(e, checked) => {
                                props.values.enableReportAndHeaderTemplateConfigurations = checked;
                                if (props.setFieldValue) {
                                  props.setFieldValue("enableReportAndHeaderTemplateConfigurations", checked);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }


              {/* {props.state.action === ACTIONS.ADD && (
                <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.send-welcome-notification")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.sendWelcomNotification}
                          value={props.values.sendWelcomNotification}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.sendWelcomNotification =
                              !props.values.sendWelcomNotification;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )} */}
              {props.userType === USERTYPES.RADIOLOGIST && (
                <>
                  {/* //Radiologst Type */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6 ">
                      <p className="single-line-form-field-key">
                        {t("user.radiologist-type")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <ChoiceGroup
                          defaultSelectedKey={props.values.radiologistType}
                          options={radiologistTypeOptions}
                          styles={choiceGroupStyles}
                          onChange={setRadiologistType}
                        />
                      </div>
                    </div>
                  </div>
                  {/* //End of radiologist type */}

                  {/* send study assign mail */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {/* {t("user.send-study-assign-mail")} */}
                        {t("user.send-study-assign-notification")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.sendAssignMail}
                          value={props.values.sendAssignMail}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.sendAssignMail =
                              !props.values.sendAssignMail;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* send study assign whatsapp */}
                  {/* <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.send-study-assign-whatsapp")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.sendAssignMail}
                          value={props.values.sendAssignMail}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.sendAssignMail =
                              !props.values.sendAssignMail;
                          }}
                        />
                      </div>
                    </div>
                  </div> */}
    {/* for admin */}
    

 <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.enable-llm-report")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.enableLlmReport}
                          value={props.values.enableLlmReport}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.enableLlmReport =
                              !props.values.enableLlmReport;
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* end of send study assign mail */}

                  {roles[0] === USERTYPES.FIRMADMIN && (
                    <>
                      {/* //Show all studies */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.show-all-studies")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.showAllStudies}
                              value={props.values.showAllStudies}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.showAllStudies =
                                  !props.values.showAllStudies;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* //End of show all studies */}

                      {/* //Disable submit */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.disable-submit")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.disableSubmit}
                              value={props.values.disableSubmit}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.disableSubmit =
                                  !props.values.disableSubmit;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* //End of disable submit */}

                      {/* on payroll */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.on-payroll")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.onPayroll}
                              value={props.values.onPayroll}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.onPayroll =
                                  !props.values.onPayroll;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* end of on payroll */}

                      {/* upload study */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.upload-study")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.uploadStudy}
                              value={props.values.uploadStudy}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.uploadStudy =
                                  !props.values.uploadStudy;
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* end of upload study */}

                      {/* QC Radiologist */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.qc-radiologist")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.qcRadiologist}
                              value={props.values.qcRadiologist}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.qcRadiologist =
                                  !props.values.qcRadiologist;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* end of QC Radiologist */}

                    

                      {/* typist workflow */}
                       
                      {/* end of typist workflow */}
                      
                    </>
                  )}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                        <>
                      <div
                        className="ms-Grid-row single-line-form-field"
                      
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.enable-typist-workflow")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Dropdown
                              styles={
                             dropDownStyle
                            }
                              options={typistWorkflowOptions}
                              defaultSelectedKey={props.values.enableTypistWorkflow}
                              onChange={(e, selection) => {
                                props.values.enableTypistWorkflow = selection.key;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      </>
                       )}
                    {/* enable history upload */}
                    {((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.RADIOLOGIST) &&(
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.enable-history-upload")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.enableHistoryUpload}
                              value={props.values.enableHistoryUpload}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.enableHistoryUpload =
                                  !props.values.enableHistoryUpload;
                              }}
                            />
                          </div>
                        </div>
                      </div>)}
                      
                      {/* end of enable history upload */}

                    {/* show client name */}
                    {((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.RADIOLOGIST) && (
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.show-client-name")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            <Checkbox
                              defaultChecked={props.values.showClientName}
                              value={props.values.showClientName}
                              styles={choiceGroupStyles}
                              onChange={() => {
                                props.values.showClientName =
                                  !props.values.showClientName;
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {/* end of show client name */}       

                  {/* Radiologist Capacity */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.radiologist-capacity")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <TextField
                          name="capacity"
                          placeholder={t("user.radiologist-capacity")}
                          type="number"
                          min={1}
                          onChange={props.handleChange}
                          value={props.values.capacity}
                          onBlur={props.handleBlur}
                          errorMessage={props.errors.capacity}
                        />
                      </div>
                    </div>
                  </div>
                  {/* end of Radiologist Capacity */}

                  {/* Check capaciity on self assignment */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key">
                          {t("user.check-capacity-on-self-assignment")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>
                          <Checkbox
                            defaultChecked={props.values.checkCapacityOnManualAssign}
                            value={props.values.checkCapacityOnManualAssign}
                            styles={choiceGroupStyles}
                            onChange={() => {
                              props.values.checkCapacityOnManualAssign =
                                !props.values.checkCapacityOnManualAssign;
                            }}
                          />
                        </div>
                      </div>
                    </div>)}
                  {/* end of  Check capaciity on self assignment */}


                  {/* enable MS Word */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                    className="ms-Grid-row single-line-form-field"
                  
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">
                        {t("user.enable-ms-word")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        <Checkbox
                          defaultChecked={props.values.showWord}
                          value={props.values.showWord}
                          styles={choiceGroupStyles}
                          onChange={() => {
                            props.values.showWord =
                              !props.values.showWord;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  )}
                  
                      {/* end of enable MS word */}

                  {/* first Modality Preference one */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">{t("user.first-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder={t("user.first-modality-preference")}
                          defaultSelectedKey={props.values.firstModalityPreference}
                          options={modalityList}
                          onChange={(e, selection) => {
                            props.values.firstModalityPreference = selection.key;
                          }}
                          errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* end of First Modality preference */}

                  {/* Second Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">{t("user.second-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder={t("user.second-modality-preference")}
                          defaultSelectedKey={props.values.secondModalityPreference}
                          options={modalityList}
                          onChange={(e, selection) => {
                            props.values.secondModalityPreference = selection.key;
                          }}
                          errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* end of Second Modality Preference */}

                  {/* Third Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key">{t("user.third-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder={t("user.third-modality-preference")}
                          defaultSelectedKey={props.values.thirdModalityPreference}
                          options={modalityList}
                          onChange={(e, selection) => {
                            props.values.thirdModalityPreference = selection.key;
                          }}
                          errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* end of Third Modality Preference */}

                  {!props.expertRadiologist && (
                    <>
                      {/* signatue text */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.signature-text")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                          <div>
                            <TextField
                              multiline
                              rows={3}
                              name="signatureText"
                              placeholder={t("user.signature-text")}
                              onChange={props.handleChange}
                              value={props.values.signatureText}
                              onBlur={props.handleBlur}
                              errorMessage={
                                props.touched.signatureText && props.errors.signatureText
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* end of signature text */}

                      {/* signature image */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key">
                            {t("user.signature-image")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            
                            {(props.state.action === ACTIONS.EDIT &&
                              props.radiologistSignatureImage != null && props.radiologistSignatureImage != "" && radiologistSignatureImage && props.values.signatureDto.isSignatureImageDeleted == 0) ? (
                                <div>
                              <img
                                style={{
                                  height: "90px",
                                  width: "150px",
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                }}
                                src={props.radiologistSignatureImage}
                                  />
                                  </div>
                            ) : (
                              <div></div>
                            )}
                            <div>
                            <input
                            style={{ width: "112px", overflow: "hidden" }}
                              type="file"
                              id="signatureFile"
                              onChange={(event) => {
                                props.values.signatureImage =
                                  event.target.files;
                                props.setRadiologistImageFileName(event.target.files[0].name);
                                props.values.signatureDto.isSignatureImageDeleted = 0;
                                props.setIsRadiologistSignatureImageDeleted(false);
                                // setRadiologistSignatureImage(true)
                                
                               
                              }}
                              className="file-input-container"
                              accept={allowedFileTypes.join(",")}
                            />
                               <label style={{ marginLeft: "10px" }} for="signatureFile">
                        {props.radiologistImageFileName}
                    </label>
                              {
                                ((props.radiologistSignatureImage != null && props.radiologistSignatureImage != "") || (props.radiologistImageFileName != null && props.radiologistImageFileName != "" && props.radiologistImageFileName != "No File Chosen")) && props.values.signatureDto.isSignatureImageDeleted == 0  && (
                                  <PrimaryButton
                      text="Clear Signature Image"
                                    className="study-list-clear-all-button"
                                    style={{ marginLeft: "5px", marginTop: "5px"}} 
                      onClick={() => {
                        props.handleClearRadiologistSignatureImage()
                        setRadiologistSignatureImage(false);
                        document.getElementById('signatureFile').value = '';
                      }
                    }
                    />)}
                            
                              </div>
                            <p
                              style={{
                                fontSize: "12px",
                                fontStyle: "italic",
                              }}
                            >
                              {t("user.signature-image-size-msg")}
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* end of signature image */}
                    </>
                  )}
                </>
              )}
            </>
          )}
          {props.state.action === ACTIONS.VIEW && (
            <>
              {/* ACTIVE STATUS OPTION TO BE SHOWN ONLY WHEN LOGGED IN USER IS NOT UPDATING ITSELF  */}
              {userId != props.values.id && (
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key form-heading">
                      {t("user.action")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>{props.values.active ? "Active" : "Inactive"}</div>
                  </div>
                </div>
              )}

              {(!(roles[0]  === USERTYPES.ADMIN  && props.values.username == 'dtadmin')) 
              && (!(roles[0]  === USERTYPES.FIRMADMIN 
              && props.userType === USERTYPES.RADIOLOGIST
              && props.values.countOfconnections > 1)) && (
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key form-heading">
                      {t("user.locked-status")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>{props.values.accountNonLocked ? "Active" : "Locked"}</div>
                  </div>
                </div>
              )}

              {twoFAGlobalEnable && (!(roles[0]  === USERTYPES.ADMIN  && props.values.username == 'dtadmin'))  &&
                !(roles[0]  === USERTYPES.FIRMADMIN && props.userType === USERTYPES.RADIOLOGIST) && (
                <div
                  className="ms-Grid-row single-line-form-field"
                >
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key form-heading">
                      {t("user.two-factor")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>{props.values.twoFactorEnabled ? "Enabled" : "Disabled"}</div>
                  </div>
                </div>)}

              {/* SHOW ASSIGNMENT CONFIRMATION OPTION TO BE SHOWN ONLY WHEN USER TYPE IS ADMIN/FIRMADMIN/SUPERVISOR  */}
              {(props.userType === USERTYPES.ADMIN ||
                props.userType === USERTYPES.FIRMADMIN ||
                props.userType === USERTYPES.SUPERVISOR) && (
                  <>
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.show-assignment-confirmation")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showConfirmation ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.enable-ms-word")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showWord ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    {getEnv("REACT_APP_VDC_PLATFORM")=="true" && 
                      <>
                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("peer-review.peer-review-team-member")}

                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.isPeerReviewAdmin ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("peer-review.peer-review-evaluator")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.isPeerReviewEvaluator ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    </>}
                  </>
                )}
               {roles[0]  === USERTYPES.ADMIN && props.userType === USERTYPES.FIRMADMIN &&
                    <>
                    <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.password-reset-allowed")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.isPasswordResetAllowed ? "Yes" : "No"}</div>
                      </div>
                    </div>
                    </>   
                }

                {roles[0]  === USERTYPES.ADMIN && (props.userType === USERTYPES.FIRMADMIN || props.userType === USERTYPES.SUPERVISOR) && 
                  <>
                        <div className="ms-Grid-row single-line-form-field">
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                              <p className="single-line-form-field-key form-heading">
                              {t("user.forced-logout-allowed")}
                              </p>
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                              <div>{props.values.isForcedLogoutAllowed ? "Yes" : "No"}</div>
                            </div>
                        </div>
                  </>
                }

                {roles[0]  === USERTYPES.ADMIN && (props.userType === USERTYPES.FIRMADMIN || props.userType === USERTYPES.SUPERVISOR || props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN) &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.export-csv-allowed")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.isExportCsvAllowed ? "Yes" : "No"}</div>
                      </div>
                    </div>
                }
                {
                ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN)&& (props.userType === USERTYPES.FIRMTECHNICIAN || props.userType === USERTYPES.SUPERVISOR || props.userType===USERTYPES.FIRMDOCTOR )) &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.enable-study-upload")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.enableStudyUpload ? "Yes" : "No"}</div>
                      </div>
                    </div>
                }

                {
                ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN)&& (props.userType===USERTYPES.FIRMDOCTOR )) &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.show-ai-results")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showAiResults ? "Yes" : "No"}</div>
                      </div>
                    </div>
                }
                {
                ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN)&& (props.userType===USERTYPES.FIRMDOCTOR)) &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.show-saved-report")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showSavedReport ? "Yes" : "No"}</div>
                      </div>
                    </div>
                }
                
                {
                ((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.FIRMDOCTOR) && (
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.allow-study-edit")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.allowStudyEdit ? "Yes" : "No"}</div>
                    </div>
                  </div>
                )
              }
                {
                ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN)&& (props.userType===USERTYPES.FIRMTECHNICIAN)) &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.show-viewer-technician")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showViewerTechnician ? "Yes" : "No"}</div>
                      </div>
                    </div>
                }
                {
                ((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.FIRMTECHNICIAN) && (
                  <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.allow-study-edit")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.allowStudyEdit ? "Yes" : "No"}</div>
                    </div>
                  </div>
                )
              }
                {
                ((roles[0] === USERTYPES.FIRMADMIN||roles[0]===USERTYPES.ADMIN)&& (props.userType===USERTYPES.FIRMTECHNICIAN )) &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("user.show-ai-results")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showAiResults ? "Yes" : "No"}</div>
                      </div>
                    </div>
                }

               {/* ENABLE MS WORD OPTION TO BE SHOWN ONLY WHEN USER IS TYPIST/RADIOLOGIST */}
                  {(props.userType === USERTYPES.TYPIST) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.enable-ms-word")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showWord ? "Yes" : "No"}</div>
                      </div>
                    </div>)}

                  {/* TYPIST PERMISSION FLAGS — VIEW mode */}
                  {(roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.FIRMADMIN) && props.userType === USERTYPES.TYPIST && (
                    <>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">Show All Studies</p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.showAllStudy ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      {props.values.showAllStudy && (
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">Connected Radiologists</p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div
                            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                            title={(props.values.connectedRadiologistIds || [])
                              .map(id => {
                                const opt = radiologistOptions.find(o => o.key === String(id));
                                return opt ? opt.text : id;
                              })
                              .join(", ")}
                          >
                            {(props.values.connectedRadiologistIds || [])
                              .map(id => {
                                const opt = radiologistOptions.find(o => o.key === String(id));
                                return opt ? opt.text : id;
                              })
                              .join(", ")}
                          </div>
                        </div>
                      </div>)}
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">Show Add Study</p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.showAddStudy ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">Show History</p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.showHistory ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">Show Viewer</p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.showViewer ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">Show Chats</p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.showChats ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">Allow Submit</p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.allowSubmit ? "Yes" : "No"}</div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* end of enable MS Word */}

                {
                (roles[0] === USERTYPES.FIRMADMIN && props.userType === USERTYPES.FIRMTECHNICIAN) &&

                      <div className="ms-Grid-row single-line-form-field">
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                        {t("hospital.enableReportAndHeaderTemplateConfigurations")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.enableReportAndHeaderTemplateConfigurations ? "Yes" : "No"}</div>
                      </div>
                    </div>
                }


              {/* SHOW RADIOLOGIST TIME SPENT TO BE SHOWN ONLY IN CASE OF SUPERVISOR USER TYPE */}
              {props.userType === USERTYPES.SUPERVISOR && (
                <>
                {((roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && props.userType === USERTYPES.SUPERVISOR) && (
                <div className="ms-Grid-row single-line-form-field">
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                    <p className="single-line-form-field-key form-heading">
                      {t("user.allow-delete-study")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>{props.values.allowDeleteStudy ? "Yes" : "No"}</div>
                  </div>
                </div>
              )}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.qc-supervisor")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.qcSupervisor ? "Yes" : "No"}</div>
                    </div>
                  </div>

                  {!!qcSupervisor && (
                      <>
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.enable-adding-annotations")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.keyImage ? "Yes" : "No"}</div>
                        </div>
                      </div>

                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.enable-save-report")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.qcSaveReport ? "Yes" : "No"}</div>
                        </div>
                      </div>

                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.qc-outsource-login")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.qcOutsourceLogin ? "Yes" : "No"}</div>
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.view-radiologist-time-spent")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        {props.values.showRadiologistTime ? "Yes" : "No"}
                      </div>
                    </div>
                  </div>

                  {!isBvpPlatform && !isVdcPlatform && (<div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.qc-capacity")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.capacity}</div>
                    </div>
                  </div>)}
                </>
              )}

              {props.userType === USERTYPES.RADIOLOGIST && (
                <>
                  {/* //Radiologst Type */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6 ">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.radiologist-type")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(
                          props.values.radiologistType,
                          radiologistTypeOptions
                        )}
                      </div>
                    </div>
                  </div>
                  {/* //End of radiologist type */}

                  {/* send study assign mail */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {/* {t("user.send-study-assign-mail")} */}
                        {t("user.send-study-assign-notification")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.sendAssignMail ? "Yes" : "No"}</div>
                    </div>
                  </div>

                 <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.enable-llm-report")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                      <div>{props.values.enableLlmReport ? "Yes" : "No"}</div>
                    </div>
                  </div>

                  {/* end of send study assign mail */}

                  {roles[0] === USERTYPES.FIRMADMIN && (
                    <>
                      {/* //Show all studies */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.show-all-studies")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            {props.values.showAllStudies ? "Yes" : "No"}
                          </div>
                        </div>
                      </div>
                      {/* //End of show all studies */}

                      {/* //Disable Submit */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.disable-submit")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>
                            {props.values.disableSubmit ? "Yes" : "No"}
                          </div>
                        </div>
                      </div>
                      {/* //End of disable submit */}

                      {/* on payroll */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.on-payroll")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.onPayroll ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      {/* end of on payroll */}

                      {/* upload study */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.upload-study")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.uploadStudy ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      {/* end of upload study */}

                      {/* QC Radiologist */}
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.qc-radiologist")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.qcRadiologist ? "Yes" : "No"}</div>
                        </div>
                      </div>

                      
                      {/* end of QC Radiologist */}
                       

                    </>
                  )}
                   {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                          <>
                      <div
                        className="ms-Grid-row single-line-form-field"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.enable-typist-workflow")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{getTextValue(props.values.enableTypistWorkflow, typistWorkflowOptions)}</div>
                        </div>
                      </div>
                      </>
                        )}
                   {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) &&(
                        <div className="ms-Grid-row single-line-form-field">
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                            <p className="single-line-form-field-key form-heading">
                              {t("user.show-client-name")}
                            </p>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                            <div>{props.values.showClientName ? "Yes" : "No"}</div>
                          </div>
                        </div>
                      )}


                        {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN)  &&(
                         <div className="ms-Grid-row single-line-form-field">
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.enable-history-upload")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div>{props.values.enableHistoryUpload ? "Yes" : "No"}</div>
                        </div>
                      </div>
                      )} 


                  {/* Radiologist Capacity */}
                  <div
                    className="ms-Grid-row single-line-form-field"
                  >
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">
                        {t("user.radiologist-capacity")}
                      </p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>{props.values.capacity}</div>
                    </div>
                  </div>
                  {/* end of Radiologist Capacity */}

                  {/* check capacity on self assignment */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.check-capacity-on-self-assignment")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.checkCapacityOnManualAssign ? "Yes" : "No"}</div>
                      </div>
                    </div>)}

                  {/* end of check capacity on self assignment */}


                  {/* enable MS Word */}
                  {(roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN) && (
                    <div
                      className="ms-Grid-row single-line-form-field"
                    >
                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                        <p className="single-line-form-field-key form-heading">
                          {t("user.enable-ms-word")}
                        </p>
                      </div>
                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                        <div>{props.values.showWord ? "Yes" : "No"}</div>
                      </div>
                    </div>)}

                  {/* end of enable MS Word */}

                  {/* first Modality Preference one */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">{t("user.first-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(props.values.firstModalityPreference,modalityList)}
                      </div>
                    </div>
                  </div> */}
                  {/* end of First Modality preference */}

                  {/* Second Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">{t("user.second-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(props.values.secondModalityPreference,modalityList)}
                      </div>
                    </div>
                  </div> */}
                  {/* end of Second Modality Preference */}

                  {/* Third Modality Preference */}
                  {/* <div className="ms-Grid-row single-line-form-field">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                      <p className="single-line-form-field-key form-heading">{t("user.third-modality-preference")}</p>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                      <div>
                        {getTextValue(props.values.thirdModalityPreference,modalityList)}
                      </div>
                    </div>
                  </div> */}
                  {/* end of Third Modality Preference */}

                  {!props.expertRadiologist && (
                    <>
                      {/* signatue text */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.signature-text")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 single-line-form-field-value">
                          <div>{props.values.signatureText}</div>
                        </div>
                      </div>
                      {/* end of signature text */}

                      {/* signature image */}
                      <div
                        className="ms-Grid-row single-line-form-field-start"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
                          <p className="single-line-form-field-key form-heading">
                            {t("user.signature-image")}
                          </p>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg8 ms-xl6 single-line-form-field-value">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {props.radiologistSignatureImage != "" ? (
                              <img
                                style={{
                                  height: "90px",
                                  width: "150px",
                                  paddingTop: "10px",
                                  paddingBottom: "10px",
                                }}
                                src={props.radiologistSignatureImage}
                              />
                            ) : (
                              <div>{t("user.no-image-found")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* end of signature image */}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SettingSection;
